import { isFuture } from "date-fns";

import { TagVariant } from "@industriousoffice/react-components";
import { Invoice, PaymentStatus } from "@/api/opb/opbTypes";

import { getDateFromYYYYMMDD } from "./date";

export function isInvoiceLate(invoice: Invoice) {
  return (
    invoice.balance > 0 &&
    !isFuture(getDateFromYYYYMMDD(invoice.dueDate)) &&
    invoice.paymentStatus === PaymentStatus.PaymentDue
  );
}
export function getInvoiceStatusTagVariant(invoice: Invoice): TagVariant {
  if (isInvoiceLate(invoice)) return TagVariant.Error;

  switch (invoice.paymentStatus) {
    case PaymentStatus.Paid:
      return TagVariant.Positive;
    case PaymentStatus.PaymentDue:
      return TagVariant.Warning;
    case PaymentStatus.Failed:
      return TagVariant.Error;
    case PaymentStatus.Processing:
      return TagVariant.Info;
    case PaymentStatus.Voided:
      return TagVariant.Warning;
    default:
      return TagVariant.Positive;
  }
}

export function getInvoiceStatus(invoice: Invoice) {
  if (isInvoiceLate(invoice)) return "Late";

  switch (invoice.paymentStatus) {
    case PaymentStatus.Paid:
      return "Paid";
    case PaymentStatus.Failed:
      return "Failed";
    case PaymentStatus.PaymentDue:
      return "Payment Due";
    case PaymentStatus.Processing:
      return "Processing";
    case PaymentStatus.Voided:
      return "Voided";
    default:
      return invoice.paymentStatus;
  }
}
